<template>
    <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingViatJaHairiot"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingViatJaHairiot"
                ref="modalHeadingViatJaHairiot"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                TODO-ViatJaHäiriötModal
            </h1>
            <button
                ref="modalButtonViatJaHairiot"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
                @keydown.tab="handleCloseButtonTab"
            />
        </header>
        <section class="modal-body modal-font">
            <span>TODO-Bodytekstiä</span>
        </section>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"

    @Component
    export default class ViatJaHairiotModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingViatJaHairiot as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        // TODO LLa jos modaalin sisältöön tulee muita interaktiivisia elementtejä closeButtonin ja otsikon lisäksi,
        // ne tulee huomioida kohdistuksen käsittelyssä (trapFocus?)
        handleCloseButtonTab(event: KeyboardEvent): void {
            if (!event.shiftKey) /* tab */ {
                (this.$refs.modalHeadingViatJaHairiot as HTMLHeadingElement).focus()
                event.preventDefault()
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.modalButtonViatJaHairiot as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
